export default __webpack_public_path__ + "static/media/forms.d3cc6f35.svg";